import { Badge } from "@/components/ui/badge";

import type { InvoiceTag } from "@/apis/gql/types";
import { AutoBuchungTag } from "@/components/shared/tags/auto-buchung";
import { Tags, tagNameToColor } from "@/lib/miscellaneous/tags";

export const TagsCell = ({ tags }: { tags: InvoiceTag[] }) => {
  return (
    <div
      className="flex flex-wrap overflow-hidden"
      style={{
        minHeight: "30px",
      }}
    >
      {tags
        ?.sort((a, b) => a.tagName.localeCompare(b.tagName))
        ?.map((tag, index) => {
          if (tag.tagName === Tags.AutoBuchung) {
            return <AutoBuchungTag />;
          }

          return (
            <Badge
              className="text-xs m-1"
              key={index.toString()}
              style={{
                backgroundColor: tagNameToColor(tag.tagName).backgroundColor,
                color: tagNameToColor(tag.tagName).textColor,
              }}
            >
              {tag.tagName}
            </Badge>
          );
        })}
    </div>
  );
};
